import ErrorIndicator from "./Error-indicator";

export default ErrorIndicator;